import {Injectable} from '@angular/core';
import {Http, Response, Headers, RequestOptions} from "@angular/http";
import {BehaviorSubject} from "rxjs/BehaviorSubject";
import {Observable} from "rxjs/Observable";
import {Player} from "./player";
import {AuthService} from "./auth.service";
import {PlayersAnswer} from "./players-answer";

@Injectable()
export class PlayerService {

  public players$: BehaviorSubject<Player[]> = new BehaviorSubject<Player[]>(null);
  public answers$: BehaviorSubject<PlayersAnswer[]> = new BehaviorSubject<PlayersAnswer[]>(null);

  constructor(private http: Http,
              private authService: AuthService) {
    authService.currentAdmin$.subscribe(res => {
      if (!res) {
        this.players$.next(null);
      }
      else {
        this.loadPlayerList();
      }
    });
  }

  public loadPlayerList() {
    this.http.get("api/players/list").subscribe(
      res => {
        let data = res.json();
        if (data.players) {
          // console.log("new players data!");
          this.players$.next(data.players);
        }
        else {
          console.log("Warning: responce had no players");
        }
      },
      error => {
        console.error(error);
      }
    );
    this.http.get("api/playersanswers/list").subscribe(
      (res: Response) => {
        let data = res.json();
        if(data.playersAnswers){
          //console.log("new list of players' answers");
          this.answers$.next(data.playersAnswers);
        }
        else{
          console.log("Warning: responce had no players' answers");
        }
      },
      (error)=>{
        console.error(error);
      });
  }

  removePlayer(id: string): Observable<boolean> {
    return this.http.delete("api/players/" + id)
      .map(res => {
        let data = res.json();
        if (data.status && data.status == "Success") {
          if (data.players) {
            //console.log("new players data!");
            this.players$.next(data.players);
          }
          else {
            console.log("Warning: responce had no Players");
          }
          return true;
        }
        return false;
      })
      .catch(this.handleError);
  }

  removeAnswer(id: string): Observable<boolean> {
    return this.http.delete("api/playersanswers/" + id)
      .map(res => {
        let data = res.json();
        if (data.status && data.status == "Success") {
          if (data.playersAnswers) {
            //console.log("new players data!");
            this.answers$.next(data.playersAnswers);
          }
          else {
            console.log("Warning: responce had no Answers");
          }
          return true;
        }
        return false;
      })
      .catch(this.handleError);
  }

  addPlayer(player: Player): Observable<boolean> {
    let body = JSON.stringify({player: player});
    let headers = new Headers({'Content-Type': 'application/json'});
    let options = new RequestOptions({headers: headers});

    return this.http.post("api/players/", body, options)
      .map(res => {
        let data = res.json();
        if (data.status && data.status == "Success") {
          if (data.players) {
            //console.log("new player data!");
            this.players$.next(data.players);
          }
          else {
            console.log("Warning: responce had no players");
          }
          return true;
        }
        return false;
      })
      .catch(this.handleError);
  }

  addNewAnswer(answer: PlayersAnswer): Observable<boolean> {
    let body = JSON.stringify({answer: answer});
    let headers = new Headers({'Content-Type': 'application/json'});
    let options = new RequestOptions({headers: headers});

    return this.http.post("api/playersanswers/", body, options)
      .map(res => {
        let data = res.json();
        if (data.status && data.status == "Success") {
          if (data.playersAnswers) {
            //console.log("new player data!");
            this.answers$.next(data.playersAnswers);
          }
          else {
            console.log("Warning: responce had no answers");
          }
          return true;
        }
        return false;
      })
      .catch(this.handleError);
  }

  updatePlayer(player: Player) : Observable<boolean> {
    let body = JSON.stringify({player: player});
    let headers = new Headers({'Content-Type': 'application/json'});
    let options = new RequestOptions({headers: headers});

    return this.http.put("api/players/", body, options)
      .map(res => {
        let data = res.json();
        if (data.status && data.status == "Success") {
          if (data.players) {
            //console.log("new player data!");
            this.players$.next(data.players);
          }
          else {
            console.log("Warning: responce had no players");
          }
          return true;
        }
        return false;
      })
      .catch(this.handleError);
  }

  private handleError(error: Response | any) {
    // In a real world app, you might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// ./src/app/player.service.ts